<template>
  <div>
    <b-alert
      show
      variant="warning"
    >
      {{ $t('auth.mfa-recovery-hint') }}
    </b-alert>

    <b-row class="mfa-codes mb-1">
      <b-col
        v-for="(code, index) in codes"
        :key="`${code}-${index}`"
        cols="12"
        md="6"
        class="mb-50"
      >
        <code dir="ltr">{{ code }}</code>
      </b-col>
    </b-row>

    <b-button
      variant="outline-primary"
      block
      class="mb-50"
      @click="copyCodes"
    >
      {{ $t('auth.mfa-copy-codes') }}
    </b-button>
    <b-button
      variant="outline-secondary"
      block
      class="mb-1"
      @click="downloadCodes"
    >
      {{ $t('auth.mfa-download-codes') }}
    </b-button>

    <b-form-checkbox
      v-model="acknowledged"
      class="mb-1"
    >
      {{ $t('auth.mfa-recovery-saved') }}
    </b-form-checkbox>

    <b-button
      variant="primary"
      block
      :disabled="!acknowledged || continuing"
      @click="$emit('continue')"
    >
      {{ $t('auth.mfa-continue') }}
      <b-spinner
        v-if="continuing"
        small
        class="ml-50"
      />
    </b-button>
  </div>
</template>

<script>
import {
  BAlert, BButton, BCol, BFormCheckbox, BRow, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'MfaRecoveryCodes',
  components: {
    BAlert,
    BButton,
    BCol,
    BFormCheckbox,
    BRow,
    BSpinner,
  },
  props: {
    codes: {
      type: Array,
      default: () => [],
    },
    continuing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      acknowledged: false,
    }
  },
  methods: {
    async copyCodes() {
      try {
        await navigator.clipboard.writeText(this.codes.join('\n'))
        this.$notifySuccess(this.$t('auth.mfa-codes-copied'))
      } catch (error) {
        this.$notifyError(error)
      }
    },
    downloadCodes() {
      const blob = new Blob([`${this.codes.join('\n')}\n`], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'okmenu-recovery-codes.txt'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.mfa-codes code {
  display: block;
  padding: 6px 8px;
  border-radius: 4px;
  background: #f8f8f8;
  font-size: 13px;
  text-align: left;
  word-break: break-all;
}

.dark-layout .mfa-codes code {
  background: #161d31;
  color: #d0d2d6;
}
</style>
